import React from 'react'
import { useIntl } from 'react-intl'
import { useMarket } from 'src/hooks/useMarket'
import styles from './styles.module.css'
import cn from 'classnames'

const BookingStatusContent = (key: string) => {
  const intl = useIntl()
  const { helpCenterUrl } = useMarket()

  return (
    <React.Fragment key={key}>
      <p className={styles.description}>
        {intl.formatMessage({ id: 'global.booking-status-intro' })}
      </p>
      <ul className={styles.description}>
        <li>
          <span className={cn(styles.strong, styles.confirmed)}>
            {intl.formatMessage({
              id: 'global.booking-status-confirmed-title',
            })}
          </span>
          {': '}
          {intl.formatMessage({ id: 'global.booking-status-confirmed-body' })}
        </li>
        <li>
          <span className={cn(styles.strong, styles.cancelled)}>
            {intl.formatMessage({
              id: 'global.booking-status-cancelled-title',
            })}
          </span>
          {': '}
          {intl.formatMessage({ id: 'global.booking-status-cancelled-body' })}
        </li>
        <li>
          <span className={cn(styles.strong, styles.pending)}>
            {intl.formatMessage({ id: 'global.booking-status-pending-title' })}
          </span>
          {': '}
          {intl.formatMessage(
            { id: 'global.booking-status-pending-body' },
            {
              help_center: (
                <a href={helpCenterUrl} target="_blank" rel="noopener noreferrer">
                  Help Center
                </a>
              ),
            }
          )}
        </li>
      </ul>
      <p className={styles.description}>
        {intl.formatMessage(
          { id: 'global.booking-status-closing' },
          {
            help_center: (
              <a href={helpCenterUrl} target="_blank" rel="noopener noreferrer">
                Help Center
              </a>
            ),
          }
        )}
      </p>
    </React.Fragment>
  )
}

export default BookingStatusContent
